export function formatEventDateTime(
  startTimeIso: string,
  endTimeIso: string,
): {
  date: string;
  time: string;
} {
  const startDate = new Date(startTimeIso);
  const startDateLocal = startDate.toLocaleDateString(
    undefined,
    getDateFormatOptions(shouldShowYear(startDate)),
  );

  const startTimeLocal = startDate.toLocaleTimeString(undefined, getTimeFormatOptions());
  const endTimeLocal = new Date(endTimeIso).toLocaleTimeString(undefined, getTimeFormatOptions());

  return {
    date: startDateLocal,
    time: `${startTimeLocal} - ${endTimeLocal}`,
  };
}

export function formatAllDayEventDateTime(
  startTimeIso: string,
  endTimeIso: string,
): {
  date: string;
  time: string;
} {
  const startDate = new Date(startTimeIso);
  const startDateLocal = startDate.toLocaleDateString(undefined, getDateFormatOptions(false));

  const endDate = new Date(endTimeIso);
  endDate.setDate(endDate.getDate() - 1);
  const showYear = shouldShowYear(startDate);
  const endDateLocal = endDate.toLocaleDateString(undefined, getDateFormatOptions(showYear));

  return {
    date: `${startDateLocal} - ${endDateLocal}`,
    time: 'All day',
  };
}

function shouldShowYear(date: Date) {
  const now = new Date();
  const oneYearFromNow = new Date(now);

  oneYearFromNow.setFullYear(now.getFullYear() + 1);
  return date.getTime() > oneYearFromNow.getTime();
}

function getDateFormatOptions(showYear: boolean): Intl.DateTimeFormatOptions {
  return {
    month: 'short',
    day: 'numeric',
    ...(showYear && { year: 'numeric' }),
  };
}

function getTimeFormatOptions(): Intl.DateTimeFormatOptions {
  return {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
}
